export default "__VITE_ASSET__CK31StWx__"